import { render, staticRenderFns } from "./ed-project-creator.vue?vue&type=template&id=ca998752&scoped=true&"
import script from "./ed-project-creator.ts?vue&type=script&lang=ts&"
export * from "./ed-project-creator.ts?vue&type=script&lang=ts&"
import style0 from "./ed-project-creator.scss?vue&type=style&index=0&id=ca998752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca998752",
  null
  
)

export default component.exports